import { Typography, Box, Card, CardContent } from "@mui/material";
import { PhonemeTooltipMap } from "shared/models";
import PhoneticKey from "./PhoneticKey";
import ipaSampaMap from "../ipa-sampa-map.json";

interface PhoneticDataItem {
  label: string;
  data: string;
}

interface PhoneticKeyboardProps {
  addValue: (value: string) => void;
  height?: string;
  data: PhoneticDataItem[];
  selectedTabIndex?: number;
  mapping: PhonemeTooltipMap;
  isIPA?: boolean;
}

// Keyboard component to display the phoneme keys
function PhoneticKeyboard({
  addValue,
  height = "auto",
  data,
  mapping,
  selectedTabIndex,
  isIPA = true,
  ...rest
}: PhoneticKeyboardProps): JSX.Element {
  const sxDefault = {
    maxWidth: "900px",
  };

  const getTooltip = (input: string) => {
    // If x-sampa then get the ipa value and then the mapping
    if (!isIPA) {
      const map = ipaSampaMap.find(
        (y: { ipa: string; sampa: string }) => y.sampa === input
      );
      if (map) {
        return mapping[map.ipa];
      }
    }
    // if IPA or if sampa-ipa mapping doesn't exist then return ipa
    return mapping[input];
  };

  return (
    <Box sx={{ ...sxDefault }} {...rest}>
      <Card
        sx={{
          height,
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ padding: 0, "&:last-child": { paddingBottom: 0 } }}>
          {data.map((item, index) => {
            const isLastItem = index === data.length - 1;

            return (
              <Box key={item.label} mb={isLastItem ? 0 : 2}>
                <Typography variant="body1" gutterBottom mb={2}>
                  {item.label}
                </Typography>
                {item.data.split("").map((itemChild: string) => (
                  <PhoneticKey
                    key={itemChild}
                    character={itemChild}
                    selectedTabIndex={selectedTabIndex}
                    onClick={() => {
                      addValue(itemChild);
                    }}
                    tooltip={getTooltip(itemChild)}
                  />
                ))}
              </Box>
            );
          })}
        </CardContent>
      </Card>
    </Box>
  );
}

export default PhoneticKeyboard;
